import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import {
  IndividualUsersRuleListComponent
} from './manage-visibility/individual-users-rule-list/individual-users-rule-list.component';
import { UsersVisiblityPage } from './users-visiblity.page';
import { IonicPaginationModule } from 'src/app/shared/components/ionic-pagination/ionic-pagination.module';
import { UsersManageVisiblityPage } from './manage-visibility/manage-visibility.page';
import { UsersService } from '../users.service';
import { StepDescriptionModule } from 'src/app/shared/components/step-description/step-description.module';
import { AddVisibilityRuleModal } from './add-rule/add-rule.modal';
import { FormsModule } from '@angular/forms';
import { GroupsService } from 'src/app/groups/groups.service';
import { PerformanceCycleService } from 'src/app/performance-cycles/performance-cycles.service';
import { AddUserVisibilityRulesComponent } from './add-user-visibility-rules/add-user-visibility-rules.component';
import { ImportVisibilityParticipantsComponent } from './import-visibility-participants/import-visibility-participants.component';
import {PageTitleInterface} from "../../shared/interfaces/page-title.interface";

const routes: Routes = [{
  path: '',
  component: UsersVisiblityPage, 
  data: { title: PageTitleInterface.UsersVisibility}
}, {
  path: ':userId',
  component: UsersManageVisiblityPage,
  data: { title: PageTitleInterface.ManageUserVisibility}
}];

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        RouterModule.forChild(routes),
        PipesModule,
        IonicPaginationModule,
        StepDescriptionModule,
        FormsModule
    ],
    declarations: [
        UsersVisiblityPage,
        UsersManageVisiblityPage,
        AddVisibilityRuleModal,
        AddUserVisibilityRulesComponent,
        ImportVisibilityParticipantsComponent,
        IndividualUsersRuleListComponent
    ],
    providers: [
        UsersService,
        GroupsService,
        PerformanceCycleService
    ]
})
export class UsersVisibilityModule { }
